module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "OverviewMap"
  }, [_c('img', {
    staticClass: "OverviewMap-img",
    attrs: {
      "src": _vm.imgUrl,
      "draggable": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "OverviewMap-currentViewport",
    style: (_vm.currentViewportStyle())
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8cdf582"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OverviewMap.vue
// module id = 427
// module chunks = 1